import React from "react";
import classes from "./CleanUp.module.css";
import { Button, Divider } from "antd";
import DefaultSelect from "../../components/form/DefaultSelect";
import DefaultInput from "../../components/form/DefaultInput";
import ButtonArrangments from "../../components/form/ButtonArrangments";
import useLang from "../../hooks/useLang";

const CleanUp = () => {
	const { strings } = useLang("cleanUp");
	return (
		<div className={classes.mainContainer}>
			<h1 className={classes.title}>{strings?.title}</h1>
			<div className={classes.heroContainer}>
				<h2 className={classes.heroTitle}>{strings?.heroTitleCache}</h2>
				<div className={classes.firstContainer}>
					<p className={classes.paragraph}>
						{strings?.cacheParagraph}
					</p>
					<Button className={classes.button}>
						{strings?.cacheButton}
					</Button>
				</div>
				<Divider />
				<div className={classes.secondContainer}>
					<h2 className={classes.heroTitle}>
						{strings?.heroTitleOldOrders}
					</h2>
					<div>
						<p>{strings?.oldOrdersParagraph1}</p>
						<p>{strings?.oldOrdersParagraph2}</p>
					</div>
					<div className={classes.inputButtonDiv}>
						<DefaultSelect
							placeholder={strings?.selectPlaceholder}
							className={classes.input}
						/>
						<Button className={classes.button}>
							{strings?.oldOrdersButton}
						</Button>
					</div>
				</div>
				<Divider />
				<div className={classes.thirdContainer}>
					<h2 className={classes.heroTitle}>
						{strings?.heroTitleCancel}
					</h2>
					<div>
						<p>{strings?.cancelParagraph}</p>
					</div>
					<div className={classes.inputButtonDiv}>
						<DefaultInput
							placeholder={strings?.inputPlaceholder}
							className={classes.input}
							label={strings?.inputLabel}
						/>
						<Button className={classes.button}>
							{strings?.cancelButton}
						</Button>
					</div>
				</div>
				<Divider />
				<ButtonArrangments text={strings?.archiveButton} />
			</div>
		</div>
	);
};

export default CleanUp;
